import globalIP from '@/GlobelIP';
import { useSelectedProducts } from '@/store/QuerySelectred';
import React from 'react';
import { Checkbox, Loader, Table, Tooltip, Whisper } from 'rsuite';
const { Column, HeaderCell, Cell } = Table;
export default function ProductTableView({
  productData,
  allQyeryData,
  allProductData,
  fetchedProducts,
  handleOpen,
  setIstouchBottom
}) {
  
  const { selectedItems, handleCheckChange, isSelectedLoading, handleSelectAllIds } =
    useSelectedProducts();

  const searchParams = new URLSearchParams(location.search);
  const con = searchParams.get('conid');
  const condition = Number(con);
  const columns = [
    !condition && {
      label: '',
      key: 'id',
      width: 80,
      fixed: true,
      renderCell: rowData => {
        const exist = allQyeryData?.some(ite => ite.productid == rowData?.id);
        return (
          <div>
            {!exist ? (
              <CheckCell
                rowData={rowData}
                productSelectedIds={selectedItems}
                handleCheckChange={handleCheckChange}
                disabled={false}
              />
            ) : (
              <Checkbox checked color="red" />
            )}
          </div>
        );
      }
    },
    {
      key: 'Image',
      label: 'Image',
      renderCell: rowData => {
        const renderTooltip = imageSrc => (
          <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
            <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
          </Tooltip>
        );

        return (
          <Whisper
            trigger="hover"
            placement="right"
            speaker={renderTooltip(
              `${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
            )}
          >
            <img
              src={`${globalIP}${rowData.attributes?.CoverImage?.data?.attributes?.url}`}
              alt="Product Image"
              style={{ width: 50, height: 50, marginTop: '-16px' }}
            />
          </Whisper>
        );
      }
    },
    {
      label: 'Alias Code',
      key: 'Alias Code',
      width: 100,
      fixed: false,
      renderCell: rowData => {
        return rowData?.attributes.ProductId;
      }
    },
    {
      label: 'Description',
      key: 'Description',
      width: 150,
      fixed: false,
      renderCell: rowData => {
        return rowData?.attributes.Description || '-';
      }
    },

    {
      label: 'Product Name',
      key: 'Product Name',
      fixed: false,
      colSpan: 4,
      width: 150,
      renderCell: rowData => {
        return rowData?.attributes.ProductName || '-';
      }
    },
    {
      label: 'Dimension',
      key: 'Dimension',
      fixed: false,
      width: 150,
      renderCell: rowData => {
        return `${rowData.attributes.Length}*${rowData.attributes.Width}*${rowData.attributes.Height}`;
      }
    },
    {
      label: 'Finish',
      key: 'Finish',
      fixed: false,
      width: 150,
      renderCell: rowData => {
        return rowData.attributes.FinishName || '-';
      }
    },
    {
      label: 'Color',
      key: 'Color',
      width: 150,
      fixed: false,
      renderCell: rowData => rowData.attributes.ColorName || '-'
    },
    {
      label: 'CBM',
      key: 'cbm',
      width: 150,
      fixed: false,
      renderCell: rowData => rowData.attributes.cbm || '-'
    }
  ];
  const handleScroll = (x, y) => {
    const contextHeight = productData.length * 46;
    const top = Math.abs(y);

    if (contextHeight - top - 500 < 20) {
      setIstouchBottom(true);
    }
    setIstouchBottom(false);
  };

  return (
    <div style={{ marginBottom: '50px' }}>
      <Table
        height={500}
        data={productData}
        id="table"
        virtualized
        onScroll={handleScroll}
        onRowClick={item => handleOpen(item.id)}
        cellBordered
      >
        {columns.map(item => {
          return (
            <Column
              width={item.key == 'id' ? 50 : null}
              fixed={item.key == 'id'}
              align="center"
              key={item.key}
              flexGrow={item.key == 'id' ? null : 1}
              fullText
            >
              <HeaderCell
                style={{ fontSize: '14px', fontWeight: 'bold', height: '100px' }}
                className="roboto-medium"
              >
                {item.label == '' ? (
                  <div style={{ textAlign: 'center' }}>
                    <Checkbox
                      onChange={() => handleSelectAllIds(allQyeryData, allProductData)}
                      indeterminate={
                        selectedItems.length > 0 && selectedItems.length < fetchedProducts.length
                      }
                      checked={selectedItems.length === fetchedProducts.length}
                    />
                  </div>
                ) : (
                  item.label
                )}
              </HeaderCell>
              <Cell dataKey={item.key} style={{ cursor: 'pointer' }}>
                {(rowData, index) =>
                  item.renderCell ? item.renderCell(rowData, index) : rowData[item.key]
                }
              </Cell>
            </Column>
          );
        })}
      </Table>

      {isSelectedLoading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0
          }}
          className="loading-bg"
        >
          <Loader size="lg" />
        </div>
      )}
    </div>
  );
}

const CheckCell = ({ rowData, productSelectedIds, handleCheckChange, disabled }) => (
  <div>
    <Checkbox
      checked={productSelectedIds.includes(rowData.id)}
      disabled={disabled}
      onChange={() =>
        handleCheckChange(
          rowData.id,
          !productSelectedIds.includes(rowData.id),
          rowData.attributes.ProductCode
        )
      }
    />
  </div>
);
